import React from "react";

function ChevronLeftSvg() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      fill="none"
      viewBox="0 0 20 20"
    >
      <path
        stroke="#667085"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M12.5 15.833L6.667 10 12.5 4.167"
      ></path>
    </svg>
  );
}

export default ChevronLeftSvg;
